<template>
  <Component :is="viewLayout">
    <template #page-heading>
      <h1 class="heading heading--large">
        Funil de sucesso
      </h1>
    </template>

    <template #page-filter>
      <CommonPageFilter
        :filters="[
          'dateRange',
          'action',
          'plugin',
          'csat',
          'feeling'
        ]"
      />
    </template>

    <template #main>
      <div class="leads-journey">
        <BaseGrid
          columns="1"
          dense
        >
          <WidgetAcquisitionFunnel/>
        </BaseGrid>
      </div>
    </template>
  </Component>
</template>

<script>
import { layoutMixin } from '@/utils/mixins'
import BaseGrid from '@/components/base/BaseGrid'
import CommonPageFilter from '@/components/common/CommonPageFilter'
import WidgetAcquisitionFunnel from '@/components/widget/WidgetAcquisitionFunnel'
import WidgetChatsSent from '@/components/widget/WidgetChatsSent'

export default {
  name: 'LeadsJourney',

  components: {
    CommonPageFilter,
    BaseGrid,
    WidgetAcquisitionFunnel,
    WidgetChatsSent
  },

  mixins: [
    layoutMixin
  ]
}
</script>

<style lang="scss" scoped>
.leads-journey {}
</style>
